import { ConfigTaskTypes } from './actionTypes';

export const getConfigTask = (data: any) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK,
  payload: data,
});

export const getConfigTaskSuccess = (configTask: any) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK_SUCCESS,
  payload: configTask,
});

export const getConfigTaskFail = (error: any) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK_FAIL,
  payload: error,
});

export const getConfigTaskDetail = (configTaskId: number) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK_DETAIL,
  configTaskId,
});

export const getConfigTaskDetailSuccess = (configTask: any) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK_DETAIL_SUCCESS,
  payload: configTask,
});

export const getConfigTaskDetailFail = (error: any) => ({
  type: ConfigTaskTypes.GET_CONFIG_TASK_DETAIL_FAIL,
  payload: error,
});

export const addConfigTask = (configTaskAdd: any) => {
  return {
    type: ConfigTaskTypes.ADD_CONFIG_TASK,
    payload: { configTaskAdd },
  };
};

export const addConfigTaskSuccess = (configTaskAdd: any) => {
  return {
    type: ConfigTaskTypes.ADD_CONFIG_TASK_SUCCESS,
    payload: configTaskAdd,
  };
};

export const addConfigTaskFail = (error: any) => {
  return {
    type: ConfigTaskTypes.ADD_CONFIG_TASK_FAIL,
    payload: error,
  };
};

export const deleteConfigTask = (id: any) => {
  return {
    type: ConfigTaskTypes.DELETE_CONFIG_TASK,
    payload: { id },
  };
};

export const deleteConfigTaskSuccess = (payload: any) => {
  return {
    type: ConfigTaskTypes.DELETE_CONFIG_TASK_SUCCESS,
    payload,
  };
};

export const deleteConfigTaskFail = (error: any) => {
  return {
    type: ConfigTaskTypes.DELETE_CONFIG_TASK_FAIL,
    payload: error,
  };
};

export const updateConfigTask = (configTask: any) => {
  return {
    type: ConfigTaskTypes.UPDATE_CONFIG_TASK,
    payload: { configTask },
  };
};

export const updateConfigTaskSuccess = (configTask: any) => {
  return {
    type: ConfigTaskTypes.UPDATE_CONFIG_TASK_SUCCESS,
    payload: configTask,
  };
};

export const updateConfigTaskFail = (error: any) => {
  return {
    type: ConfigTaskTypes.UPDATE_CONFIG_TASK_FAIL,
    payload: error,
  };
};
